import { processName } from "../../utils/adaByron";
import { api } from "../../utils/monitoringUtils";
import Request, { getMockedInfo } from "../../utils/request";
import Sonda from "../../utils/sonda";
import {
  Context,
  ENV_NAME,
  MethodType,
  UnknownObject,
} from "../../utils/types";

enum PATHS {
  GET_BY_NAME = "/cms/{kind}/getByName",
}
/* GET BY NAME */
let newTabOpen = false;

export const getByNameError = (
  response: XMLHttpRequest,
  envName = "",
  endpoint: string
): null => {
  if (
    !newTabOpen &&
    (envName === ENV_NAME.QA || envName === ENV_NAME.DEV) &&
    response &&
    response.statusText === "Network Error"
  ) {
    newTabOpen = true;
    try {
      window.open(endpoint);
    } catch (err) {
      console.log(`[Error Opening Custo Tab]: ${err}`);
    }
  }
  return null;
};

export const getByName = (
  data: UnknownObject,
  kind = "activity",
  idFront = "VT"
): Promise<unknown> => {
  const myData = { ...data };
  const context = myData.context as Context;
  const idRequest = api.getUUID(idFront);
  const sonda = new Sonda({
    eventName: "CUSTOMIZER.ACTIVITY.GETBYNAME",
    context,
    uniqueId: idRequest,
    origin: processName,
  });

  const { custo: connectionData, name } = context.environment;
  const { endpoint: host, headers } = connectionData;

  const URL_API = `${host}${PATHS.GET_BY_NAME.replace(
    "{kind}",
    kind
  )}?${idRequest}`;

  const mockInfo = getMockedInfo("getByName", name);

  try {
    const request = new Request({
      method: MethodType.POST,
      endpoint: URL_API,
      data: myData,
      onError: (response: XMLHttpRequest) =>
        getByNameError(response, name, URL_API),
      sonda,
      headers,
      mockInfo,
    });

    return request.makeRequest();
  } catch (err) {
    console.log(err);
    sonda.errorJs(err);
    return null;
  }
};
